// import { CommonDateRange, CrossButton, CustomPagination, CustomSelect } from 'components'
// import React, { useContext, useEffect, useState } from 'react';
// import moment from "moment";
// import './addSupplierPay.css'
// import { IoCheckbox, IoSquareOutline } from 'react-icons/io5';
// import { StorageServices } from 'utils';
// import { supplierTripListApi } from '_services/accountsServices/supplierServices';
// import { UserContext } from 'context';
// import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
// import { getAllVehicleNumber } from '_services';
// import toast from 'react-hot-toast';

// const AddSupplierPayment = (props) => {
//     let { isOpen, onClose, supplierDetails, continueForPayment } = props;

//     const { masterData } = useContext(UserContext)
//     const [selectedRange, setSelectedRange] = useState({
//         startDate: moment().startOf('month'),
//         endDate: moment().endOf('month'),
//     });
//     const companyId = StorageServices.getCompanyId()
//     const [isLoading, setIsLoading] = useState(false)
//     const itemsPerPage = 25;
//     const [totalItems, setTotalItems] = useState(0);
//     const [filter, setFilter] = useState({
//         limit: 25,
//         offset: 1,
//         search: '',
//         status: 0,
//         vehicle_id: ""
//     });
//     const [suppliertripList, setSuppliertripList] = useState([])
//     const [selectedTrips, setSelectedTrips] = useState([]) // {trip_id, amount}
//     const tripList = masterData?.trip_status_list?.map((i) => ({ ...i, label: i?.name, value: i?.id })) || []

//     const handleApply = (newRange) => {
//         setSelectedRange(newRange);
//     };

//     const supplierTripPayHandle = async (data) => {
//         const payload = {
//             company_id: companyId,
//             branch_id: "",
//             supplier_id: data?._id,
//             trip_status: filter?.status,
//             vehicle_id: filter?.vehicle_id?._id,
//             start_date: moment(selectedRange?.startDate).format("YYYY-MM-DD"),
//             end_date: moment(selectedRange?.endDate).format("YYYY-MM-DD"),
//             search: filter?.search,
//             limit: filter?.limit,
//             offset: filter?.offset
//         }

//         try {
//             setIsLoading(true)

//             const res = await supplierTripListApi(payload)

//             if (res?.responseCode == 200) {
//                 setSuppliertripList(res?.data?.trip_list)
//                 setTotalItems(res?.data?.total_record)
//             }
//         } catch (error) {

//         } finally {
//             setIsLoading(false)
//         }
//     }

//     const fetchVehicle = async (search, page, limit) => {
//         const res = await getAllVehicleNumber({
//             company_id: companyId,
//             offset: page,
//             limit,
//             search,
//         });
//         if (res?.responseCode === 200) {
//             const list = res?.data?.vehicle_list?.map((i) => ({
//                 ...i,
//                 name: `${i?.vehicle_no}`,
//                 ownershipStatus: i?.vehicle_ownership,
//             }));
//             return {
//                 items: list,
//                 total: res?.data?.total_record,
//             };
//         } else {
//             return { items: [], total: 0 };
//         }
//     };

//     useEffect(() => {
//         if (supplierDetails?._id) {
//             supplierTripPayHandle(supplierDetails)
//         }
//     }, [supplierDetails, filter, selectedRange])

//     const handlePageChange = (page) => {
//         setFilter((s) => ({ ...s, offset: page }))
//     };

//     // Checkbox toggle handler - WITH VALIDATION
//     const handleCheckboxToggle = (trip) => {
//         const isSelected = selectedTrips.find(t => t.trip_id === trip._id);

//         if (isSelected) {
//             // Remove from selection
//             setSelectedTrips(selectedTrips.filter(t => t.trip_id !== trip._id));
//         } else {
//             // Add to selection with balance amount (not 0)
//             const balanceAmount = trip?.freight_summary?.balance || 0;
//             setSelectedTrips([...selectedTrips, {
//                 trip_id: trip._id,
//                 trip_number: trip?.trip_number,
//                 amount: balanceAmount > 0 ? balanceAmount : 0
//             }]);
//         }
//     };

//     // Payment amount change handler - WITH VALIDATION
//     const handlePaymentChange = (tripId, value) => {
//         // Find the trip to get balance amount
//         const trip = suppliertripList.find(t => t._id === tripId);
//         const maxBalance = trip?.freight_summary?.balance || 0;

//         // If empty string, set to empty
//         if (value === '') {
//             setSelectedTrips(selectedTrips.map(trip =>
//                 trip.trip_id === tripId
//                     ? { ...trip, amount: '' }
//                     : trip
//             ));
//             return;
//         }

//         // Convert to number
//         let numValue = parseFloat(value);

//         // If invalid number, don't update
//         if (isNaN(numValue)) {
//             return;
//         }

//         // Validation: Amount should not be negative or 0
//         if (numValue <= 0) {
//             return; // Don't update if trying to enter 0 or negative
//         }

//         // Validation: Amount should not exceed balance
//         if (numValue > maxBalance) {
//             // Show toast notification to user - don't update the value
//             toast.error(`Amount cannot exceed balance amount of ₹${maxBalance.toFixed(2)}`);
//             return; // Don't update state
//         }

//         setSelectedTrips(selectedTrips.map(trip =>
//             trip.trip_id === tripId
//                 ? { ...trip, amount: numValue }
//                 : trip
//         ));
//     };

//     // Get payment status
//     const getPaymentStatus = (trip) => {
//         const selectedTrip = selectedTrips.find(t => t.trip_id === trip._id);
//         if (!selectedTrip) return null;

//         const totalFreight = trip?.freight_summary?.balance || 0;
//         const paidAmount = selectedTrip.amount;

//         if (paidAmount >= totalFreight) {
//             return 'full';
//         } else if (paidAmount > 0) {
//             return 'partial';
//         }
//         return null;
//     };

//     // Get trip status name
//     const getTripStatusName = (statusId) => {
//         const status = tripList.find(t => t.id === statusId);
//         return status?.name || '';
//     };

//     // Check if trip is selected
//     const isSelected = (tripId) => {
//         return selectedTrips.some(t => t.trip_id === tripId);
//     };

//     // Get input value for trip
//     const getInputValue = (tripId) => {
//         const trip = selectedTrips.find(t => t.trip_id === tripId);
//         return trip?.amount || '';
//     };

//     const calculateTotalPayment = () => {
//         return selectedTrips.reduce((sum, trip) => {
//             return sum + (parseFloat(trip.amount) || 0);
//         }, 0);
//     };

//     return (
//         <>
//             <div className="offcanvas-header">
//                 <h5 className="offcanvas-title">Select Supplier Trip for Payment</h5>
//                 <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => onClose(!isOpen)}>
//                     <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
//                         <path
//                             d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
//                             fill="black" />
//                     </svg>
//                 </CrossButton>
//             </div>

//             <div className="offcanvas-body">
//                 <div className='__supsAdd_bg'>
//                     <div className='__payTop_flex'>
//                         <div className="_divForth" style={{ flex: '0 0 310px' }}>
//                             <CommonDateRange
//                                 initialStartDate={selectedRange.startDate}
//                                 initialEndDate={selectedRange.endDate}
//                                 onApply={handleApply}
//                             />
//                         </div>

//                         <div className='__paySearch_fxs'>
//                             <CustomSelect
//                                 options={tripList}
//                                 placeholder="Trip Status"
//                                 value={tripList?.find((f) => f?.id == filter?.status)}
//                                 onSelect={(data) => {
//                                     setFilter((pre) => ({ ...pre, status: data?.value }))
//                                 }}
//                             />
//                         </div>

//                         <div className='__paySearch_fxs'>
//                             <CustomSelect
//                                 options={[]}
//                                 placeholder="POD Status"
//                             />
//                         </div>

//                         <div className='__paySearch_fxs'>
//                             <SingleSelectDropdownInfinite
//                                 placeholder="Vehicle Number"
//                                 fetchData={fetchVehicle}
//                                 selectedItem={filter?.vehicle_id}
//                                 onChange={(data) => {
//                                     setFilter((pre) => ({ ...pre, vehicle_id: data }))
//                                 }}
//                                 loadOnOpen={true}
//                             />
//                         </div>
//                     </div>

//                     <div className='__addPayTable_bx'>
//                         <table>
//                             <thead>
//                                 <tr>
//                                     <th style={{ width: '2%' }}><div></div></th>
//                                     <th><div>Trip Date</div></th>
//                                     <th><div>Trip Number</div></th>
//                                     <th><div>Route</div></th>
//                                     <th><div>Vehicle number</div></th>
//                                     <th style={{ width: '9%' }}><div>Trip Status</div></th>
//                                     <th style={{ width: '15%' }}><div>POD Status</div></th>
//                                     <th><div>Payment</div></th>
//                                     <th>Balance Due</th>
//                                 </tr>
//                             </thead>

//                             {suppliertripList?.length === 0 ? (
//                                 <tbody>
//                                     <tr>
//                                         <td colSpan="9" style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
//                                             No Data Available
//                                         </td>
//                                     </tr>
//                                 </tbody>
//                             ) : (
//                                 suppliertripList?.map((trip) => {
//                                     const paymentStatus = getPaymentStatus(trip);
//                                     const selected = isSelected(trip._id);

//                                     return (
//                                         <tbody className='__pdTd_bxs' key={trip._id}>
//                                             <tr
//                                                 className={`__paySclIn_bx ${paymentStatus === 'full' ? '__fulPay_bxs' :
//                                                     paymentStatus === 'partial' ? '__partialPay_bxs' :
//                                                         '__totalPay_bxs'
//                                                     }`}
//                                             >
//                                                 <td>
//                                                     <div
//                                                         className={selected ? '__chkPYap' : '__disable_chkPYap'}
//                                                         onClick={() => handleCheckboxToggle(trip)}
//                                                         style={{ cursor: 'pointer' }}
//                                                     >
//                                                         {selected ? <IoCheckbox /> : <IoSquareOutline />}
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div>
//                                                         {moment(trip?.dispatch_date).format('DD/M/YYYY') || ""}
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='__supTrip_nums'>
//                                                         {trip?.trip_number || ''}
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div>{trip?.route_name || ''}</div>
//                                                 </td>
//                                                 <td>
//                                                     <div>{trip?.vehicle_id?.vehicle_no || 'MP20GA2109'}</div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='__trpDeliver_stats'>
//                                                         {getTripStatusName(trip?.trip_status)}
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='__pod_stats'>
//                                                         {trip?.to_location?.[0]?.lr_list?.length > 0
//                                                             ? `POD Pending (${trip.to_location[0].lr_list.length})`
//                                                             : 'POD Pending (2)'
//                                                         }
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='__sPay_input'>
//                                                         <input
//                                                             type="text"
//                                                             value={getInputValue(trip._id)}
//                                                             onChange={(e) => handlePaymentChange(trip._id, e.target.value)}
//                                                             disabled={!selected}
//                                                         />
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='__mainPaid_bxs'>
//                                                         <div>/ ₹ {trip?.freight_summary?.balance?.toFixed(2) || '0.00'}</div>
//                                                         {paymentStatus === 'full' && (
//                                                             <div className='__trpDeliver_stats'>Full Payment</div>
//                                                         )}
//                                                         {paymentStatus === 'partial' && (
//                                                             <div className='__pod_stats'>Partial Payment</div>
//                                                         )}
//                                                     </div>
//                                                 </td>
//                                             </tr>
//                                         </tbody>
//                                     );
//                                 })
//                             )}
//                         </table>
//                     </div>

//                     {suppliertripList?.length > 0 && <div className="paginationFt_avt " style={{ borderBottom: 'none' }}>
//                         <CustomPagination
//                             totalItems={totalItems}
//                             itemsPerPage={itemsPerPage}
//                             currentPage={filter.offset}
//                             onPageChange={handlePageChange}
//                         />
//                     </div>}
//                 </div>
//             </div>

//             <div className='offcanvas-footer' style={{ display: 'flex', justifyContent: "space-between" }}>
//                 <div style={{ display: 'flex', gap: "10px" }}>
//                     <button
//                         className='_addComm_btn _sameWid'
//                         onClick={() => {
//                             continueForPayment(selectedTrips, calculateTotalPayment())
//                         }}
//                         disabled={selectedTrips.length === 0}
//                         style={{
//                             opacity: selectedTrips.length === 0 ? 1 : 1,
//                             cursor: selectedTrips.length === 0 ? 'not-allowed' : 'pointer'
//                         }}
//                     >
//                         Continue
//                     </button>
//                     <button
//                         className='_cancel_btn _sameWid'
//                         onClick={() => onClose(!isOpen)}
//                     >
//                         Cancel
//                     </button>
//                 </div>
//                 <span>
//                     {`Total Payment ₹ ${calculateTotalPayment().toFixed(2)}`}
//                 </span>

//             </div>
//         </>
//     )
// }

// export default AddSupplierPayment

import { CommonDateRange, CrossButton, CustomPagination, CustomSelect } from 'components'
import React, { useContext, useEffect, useState } from 'react';
import moment from "moment";
import './addSupplierPay.css'
import { IoCheckbox, IoSquareOutline } from 'react-icons/io5';
import { StorageServices } from 'utils';
import { supplierTripListApi } from '_services/accountsServices/supplierServices';
import { UserContext } from 'context';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import { getAllVehicleNumber } from '_services';
import toast from 'react-hot-toast';

const AddSupplierPayment = (props) => {
    let { isOpen, onClose, supplierDetails, continueForPayment } = props;

    const { masterData } = useContext(UserContext)
    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
    });
    const companyId = StorageServices.getCompanyId()
    const [isLoading, setIsLoading] = useState(false)
    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
        status: 0,
        vehicle_id: "",
        pod_status: 1
    });
    const [suppliertripList, setSuppliertripList] = useState([])
    const [selectedTrips, setSelectedTrips] = useState([]) // {trip_id, amount}
    const tripList = masterData?.trip_status_list?.map((i) => ({ ...i, label: i?.name, value: i?.id })) || []
    const [masterDataPodStatus, setMasterDataPodStatus] = useState([]);

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
    };

    const handleResetFilters = () => {
        setSelectedRange({
            startDate: moment().startOf('month'),
            endDate: moment().endOf('month'),
        });
        setFilter({
            limit: 25,
            offset: 1,
            search: '',
            status: 0,
            vehicle_id: ""
        });
        setSelectedTrips([]);
    };

    const supplierTripPayHandle = async (data) => {
        const payload = {
            company_id: companyId,
            branch_id: "",
            supplier_id: data?._id,
            trip_status: filter?.status,
            vehicle_id: filter?.vehicle_id?._id,
            start_date: moment(selectedRange?.startDate).format("YYYY-MM-DD"),
            end_date: moment(selectedRange?.endDate).format("YYYY-MM-DD"),
            search: filter?.search,
            limit: filter?.limit,
            offset: filter?.offset,
            pod_status:filter?.pod_status
        }

        try {
            setIsLoading(true)

            const res = await supplierTripListApi(payload)

            if (res?.responseCode == 200) {
                setSuppliertripList(res?.data?.trip_list)
                setTotalItems(res?.data?.total_record)
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    }

    const fetchVehicle = async (search, page, limit) => {
        const res = await getAllVehicleNumber({
            company_id: companyId,
            offset: page,
            limit,
            search,
        });
        if (res?.responseCode === 200) {
            const list = res?.data?.vehicle_list?.map((i) => ({
                ...i,
                name: `${i?.vehicle_no}`,
                ownershipStatus: i?.vehicle_ownership,
            }));
            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            return { items: [], total: 0 };
        }
    };

    useEffect(() => {
        if (supplierDetails?._id) {
            supplierTripPayHandle(supplierDetails)
        }
    }, [supplierDetails, filter, selectedRange])

    useEffect(() => {

        if (masterData?.pod_status_list) {
            setMasterDataPodStatus(masterData?.pod_status_list?.map((el) => {
                return {
                    ...el,
                    label: el?.name,
                    value: el?.id,
                };
            }))
        }
    }, [masterData])

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    // Checkbox toggle handler - WITH VALIDATION
    const handleCheckboxToggle = (trip) => {
        const isSelected = selectedTrips.find(t => t.trip_id === trip._id);

        if (isSelected) {
            // Remove from selection
            setSelectedTrips(selectedTrips.filter(t => t.trip_id !== trip._id));
        } else {
            // Add to selection with balance amount (not 0)
            const balanceAmount = trip?.freight_summary?.balance || 0;
            setSelectedTrips([...selectedTrips, {
                trip_id: trip._id,
                trip_number: trip?.trip_number,
                amount: balanceAmount > 0 ? balanceAmount : 0
            }]);
        }
    };

    // Payment amount change handler - WITH VALIDATION
    const handlePaymentChange = (tripId, value) => {
        // Find the trip to get balance amount
        const trip = suppliertripList.find(t => t._id === tripId);
        const maxBalance = trip?.freight_summary?.balance || 0;

        // If empty string, set to empty
        if (value === '') {
            setSelectedTrips(selectedTrips.map(trip =>
                trip.trip_id === tripId
                    ? { ...trip, amount: '' }
                    : trip
            ));
            return;
        }

        // Convert to number
        let numValue = parseFloat(value);

        // If invalid number, don't update
        if (isNaN(numValue)) {
            return;
        }

        // Validation: Amount should not be negative or 0
        if (numValue <= 0) {
            return; // Don't update if trying to enter 0 or negative
        }

        // Validation: Amount should not exceed balance
        if (numValue > maxBalance) {
            // Show toast notification to user - don't update the value
            toast.error(`Amount cannot exceed balance amount of ₹${maxBalance.toFixed(2)}`);
            return; // Don't update state
        }

        setSelectedTrips(selectedTrips.map(trip =>
            trip.trip_id === tripId
                ? { ...trip, amount: numValue }
                : trip
        ));
    };

    // Get payment status
    const getPaymentStatus = (trip) => {
        const selectedTrip = selectedTrips.find(t => t.trip_id === trip._id);
        if (!selectedTrip) return null;

        const totalFreight = trip?.freight_summary?.balance || 0;
        const paidAmount = selectedTrip.amount;

        if (paidAmount >= totalFreight) {
            return 'full';
        } else if (paidAmount > 0) {
            return 'partial';
        }
        return null;
    };

    // Get trip status name
    const getTripStatusName = (statusId) => {
        const status = tripList.find(t => t.id === statusId);
        return status?.name || '';
    };

    // Check if trip is selected
    const isSelected = (tripId) => {
        return selectedTrips.some(t => t.trip_id === tripId);
    };

    // Get input value for trip
    const getInputValue = (tripId) => {
        const trip = selectedTrips.find(t => t.trip_id === tripId);
        return trip?.amount || '';
    };

    const calculateTotalPayment = () => {
        return selectedTrips.reduce((sum, trip) => {
            return sum + (parseFloat(trip.amount) || 0);
        }, 0);
    };

     const isContinueDisabled = () => {
        if (selectedTrips.length === 0) return true;
        return selectedTrips.some(trip => !trip.amount || trip.amount === '' || parseFloat(trip.amount) <= 0);
    };

    return (
        <>
            <div className="offcanvas-header">
                <h5 className="offcanvas-title">Select Supplier Trip for Payment</h5>
                <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => onClose(!isOpen)}>
                    <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path
                            d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                            fill="black" />
                    </svg>
                </CrossButton>
            </div>

            <div className="offcanvas-body">
                <div className='__supsAdd_bg'>
                    <div className='__payTop_flex'>
                        <div className="_divForth" style={{ flex: '0 0 310px' }}>
                            <CommonDateRange
                                initialStartDate={selectedRange.startDate}
                                initialEndDate={selectedRange.endDate}
                                onApply={handleApply}
                            />
                        </div>

                        <div className='__paySearch_fxs'>
                            <CustomSelect
                                options={tripList}
                                placeholder="Trip Status"
                                value={filter?.status ? tripList?.find((f) => f?.id == filter?.status) : { label: "", value: "" }}
                                onSelect={(data) => {
                                    setFilter((pre) => ({ ...pre, status: data?.value }))
                                }}
                            />
                        </div>

                        <div className='__paySearch_fxs'>
                            <CustomSelect
                                options={masterDataPodStatus}
                                placeholder="POD Status"
                                value={filter?.pod_status ? masterDataPodStatus?.find((f) => f?.id == filter?.pod_status) : { label: "", value: "" }}
                                onSelect={(data) => {
                                    setFilter((pre) => ({ ...pre, pod_status: data?.value }))
                                }}
                            />
                        </div>

                        <div className="_divForth" style={{ flex: '0 0 310px' }}>
                            <SingleSelectDropdownInfinite
                                placeholder="Vehicle Number"
                                fetchData={fetchVehicle}
                                selectedItem={filter?.vehicle_id}
                                onChange={(data) => {
                                    setFilter((pre) => ({ ...pre, vehicle_id: data }))
                                }}
                                loadOnOpen={true}
                            />
                        </div>

                        <button
                            className='_resetApl_btn'

                            onClick={handleResetFilters}
                            style={{ padding: '8px 16px', whiteSpace: 'nowrap', borderRadius: "5px" }}
                        >
                            Reset
                        </button>
                    </div>

                    <div className='__addPayTable_bx'>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '2%' }}><div></div></th>
                                    <th><div>Trip Date</div></th>
                                    <th><div>Trip Number</div></th>
                                    <th><div>Route</div></th>
                                    <th><div>Vehicle number</div></th>
                                    <th style={{ width: '9%' }}><div>Trip Status</div></th>
                                    <th style={{ width: '15%' }}><div>POD Status</div></th>
                                    <th><div>Payment</div></th>
                                    <th>Balance Due</th>
                                </tr>
                            </thead>

                            {suppliertripList?.length === 0 ? (
                                <tbody>
                                    <tr>
                                        <td colSpan="9" style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
                                            No Data Available
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                                suppliertripList?.map((trip) => {
                                    const paymentStatus = getPaymentStatus(trip);
                                    const selected = isSelected(trip._id);

                                    return (
                                        <tbody className='__pdTd_bxs' key={trip._id}>
                                            <tr
                                                className={`__paySclIn_bx ${paymentStatus === 'full' ? '__fulPay_bxs' :
                                                    paymentStatus === 'partial' ? '__partialPay_bxs' :
                                                        '__totalPay_bxs'
                                                    }`}
                                            >
                                                <td>
                                                    <div
                                                        className={selected ? '__chkPYap' : '__disable_chkPYap'}
                                                        onClick={() => handleCheckboxToggle(trip)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {selected ? <IoCheckbox /> : <IoSquareOutline />}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        {moment(trip?.dispatch_date).format('DD/M/YYYY') || ""}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='__supTrip_nums'>
                                                        {trip?.trip_number || ''}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>{trip?.route_name || ''}</div>
                                                </td>
                                                <td>
                                                    <div>{trip?.vehicle_id?.vehicle_no || 'MP20GA2109'}</div>
                                                </td>
                                                <td>
                                                    <div className='__trpDeliver_stats'>
                                                        {getTripStatusName(trip?.trip_status)}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='__pod_stats'>
                                                        {trip?.to_location?.[0]?.lr_list?.length > 0
                                                            ? `POD Pending (${trip.to_location[0].lr_list.length})`
                                                            : 'POD Pending (2)'
                                                        }
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='__sPay_input'>
                                                        <input
                                                            type="text"
                                                            value={getInputValue(trip._id)}
                                                            onChange={(e) => handlePaymentChange(trip._id, e.target.value)}
                                                            disabled={!selected}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='__mainPaid_bxs'>
                                                        <div>/ ₹ {trip?.freight_summary?.balance?.toFixed(2) || '0.00'}</div>
                                                        {paymentStatus === 'full' && (
                                                            <div className='__trpDeliver_stats'>Full Payment</div>
                                                        )}
                                                        {paymentStatus === 'partial' && (
                                                            <div className='__pod_stats'>Partial Payment</div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    );
                                })
                            )}
                        </table>
                    </div>

                    {suppliertripList?.length > 0 && <div className="paginationFt_avt " style={{ borderBottom: 'none' }}>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter.offset}
                            onPageChange={handlePageChange}
                        />
                    </div>}
                </div>
            </div>

            <div className='offcanvas-footer' style={{ display: 'flex', justifyContent: "space-between" }}>
                <div style={{ display: 'flex', gap: "10px" }}>
                    <button
                        className='_addComm_btn _sameWid'
                        onClick={() => {
                            continueForPayment(selectedTrips, calculateTotalPayment())
                        }}
                        disabled={isContinueDisabled()}
                        style={{
                            opacity: isContinueDisabled() && 1,
                            cursor: isContinueDisabled() ? 'not-allowed' : 'pointer'
                        }}
                    >
                        Continue
                    </button>
                    <button
                        className='_cancel_btn _sameWid'
                        onClick={() => onClose(!isOpen)}
                    >
                        Cancel
                    </button>
                </div>
                <span>
                    {`Total Payment ₹ ${calculateTotalPayment().toFixed(2)}`}
                </span>

            </div>
        </>
    )
}

export default AddSupplierPayment